var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFacebookCanpcc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "facebook",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 9 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "social",
    "data-name": "Facebook"
  }, /*#__PURE__*/React.createElement("g", {
    id: "social",
    "data-name": "Facebook"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25,10.36v2.95H23.24a1.64,1.64,0,0,0-1.29.4,1.84,1.84,0,0,0-.33,1.21V17h3.27l-.44,3.3H21.61V28.8H18.19V20.33H15.35V17h2.85V14.59a4.32,4.32,0,0,1,1.16-3.22,4.21,4.21,0,0,1,3.09-1.14A18.54,18.54,0,0,1,25,10.36Z",
    transform: "translate(-15.35 -10.23)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookCanpcc);
export default __webpack_public_path__ + "static/media/facebook_canpcc.579caf239782154f9a1a12f6fd475587.svg";
export { ForwardRef as ReactComponent };